var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg14Dai3Zisangyou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9E1284;}\n\t.st1{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20,
    cy: 6,
    r: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26,22 26,10 20,10 14,10 14,22 12,22 12,18 10,18 10,14 2,14 2,22 0,22 0,28 28,28 28,22  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.7,6.5v1H5v1H2.7v1H5V12h1.7V9.5h2.3v-1H6.8v-1h2.3v-1H7.3L10,2H7.9L6.6,4.7C6.4,5.3,6.2,5.8,5.9,6.3 c-0.2-0.6-0.3-1-0.6-1.6L4.1,2H2l2.5,4.5H2.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14Dai3Zisangyou);
export default __webpack_public_path__ + "static/media/14_dai3zisangyou.10b2240afef900f126dd48b3415c8c7e.svg";
export { ForwardRef as ReactComponent };